var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.customers)?_c('ui-panel',[_c('ui-flex',[_c('ui-cell',[_c('ui-wizard-button',{attrs:{"secondary":""},on:{"click":_vm.remove}},[_vm._v("Integration entfernen")])],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }